import { createActionGroup, props } from '@ngrx/store';
import { SalesTransaction, CreateSalesTransactionDto } from '../../models/sales-transaction.model';

export const SalesTransactionsActions = createActionGroup({
  source: 'SalesTransactions',
  events: {
    'Load Sales Transactions': props<{ customerId?: number }>(),
    'Load Sales Transactions Success': props<{ transactions: SalesTransaction[] }>(),
    'Load Sales Transactions Failure': props<{ error: string }>(),
    'Load Sales Transaction': props<{ id: number }>(),
    'Load Sales Transaction Success': props<{ transaction: SalesTransaction }>(),
    'Load Sales Transaction Failure': props<{ error: string }>(),
    'Create Sales Transaction': props<{ dto: CreateSalesTransactionDto }>(),
    'Create Sales Transaction Success': props<{ transaction: SalesTransaction }>(),
    'Create Sales Transaction Failure': props<{ error: string }>(),
    'Delete Sales Transaction': props<{ id: number }>(),
    'Delete Sales Transaction Success': props<{ id: number }>(),
    'Delete Sales Transaction Failure': props<{ error: string }>(),
  }
});
